import React from 'react'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import withHandlers from 'recompose/withHandlers'
import compose from 'recompose/compose'
import videojs from 'video.js'
import 'videojs-youtube'
import panorama from './PanoVidPlugin/dist/videojs-panorama.common.js'
import style from './css/videoPlayerStyle.js'
import EmbeddedTitleDisplay from './videoPlayerSubcomponents/EmbeddedTitleDisplay'
import BackToSceneButton from './videoPlayerSubcomponents/BackToSceneButton'
import SettingMenu from './videoPlayerSubcomponents/SettingMenu'
import SettingMenuButton from './videoPlayerSubcomponents/SettingMenuButton'
import VimeoPlayer from './VimeoPlayer'
import DraggingHint from '../../../containers/common/DraggingHint'

// import CaptionMenu from './CaptionMenu';
// import CaptionMenuButton from './CaptionMenuButton';

const handlers = withHandlers({
    handleClick: ({ state, progress, onClick }) => onClick && onClick({ state, progress }),
})

const vjsComponent = videojs.getComponent('Component')

/**
 * Make sure to register the vjsComponent so Video JS knows it exists
 */

vjsComponent.registerComponent('settingMenuButton', SettingMenuButton)
vjsComponent.registerComponent('settingMenu', SettingMenu)

vjsComponent.registerComponent('embeddedTitleDisplay', EmbeddedTitleDisplay)
vjsComponent.registerComponent('backToSceneButton', BackToSceneButton)

// vjsComponent.registerComponent('captionsMenu', CaptionMenu);
// vjsComponent.registerComponent('captionMenuButton', CaptionMenuButton);

const CursorState = {
    GRAB: 'grab',
    GRABBING: 'grabbing',
}

class VideoPlayer extends React.PureComponent {
    constructor(props) {
        super(props)
        const { src, media_is360 } = this.props
        this.state = {
            displayResMenu: false,
            displayCaptionsMenu: false,
            videoLoaded: false,
            src,
            cursor: media_is360 ? CursorState.GRAB : 'default',
        }

        this.boundSetDisplayResMenu = this._setDisplayResMenu.bind(this)
        this.boundSetNewSource = this._setNewSource.bind(this)
        this.boundSetNewSubtitles = this._setNewSubtitles.bind(this)
        this.boundHandleOnMouseDown = this.handleOnMouseDown.bind(this)
        this.boundHandleOnMouseUp = this.handleOnMouseUp.bind(this)
        this.boundSetVideoLoadedTrue = this._setVideoLoadedTrue.bind(this)
    }

    handleNewSourceLoadedMetaData = () => {
        // Resets to current time when metadata is loaded and plays
        this.player.currentTime(currentTime)
        this.player.play()
        this.player.getChild('controlBar').removeChild('settingMenu')
        this.setState({ displayResMenu: false })
    }

    _setNewSource(src) {
        // https://stackoverflow.com/questions/9870552/how-to-get-current-playback-time-in-video-js
        const currentTime = this.player.currentTime()
        // Sets to new src
        this.player.src(src)
        this.setState({ src })

        this.player.on('loadedmetadata', this.handleNewSourceLoadedMetaData)
    }

    _setVideoLoadedTrue() {
        const { videoLoaded } = this.state
        this.setState({ videoLoaded: true })
    }

    _setNewSubtitles(src) {
        // SET SUBTITLES HERE
        // TBD
    }

    _setDisplayCaptionsMenu() {
        const { classes, captionOptions } = this.props
        const { displayCaptionsMenu } = this.state
        if (displayCaptionsMenu) {
            this.player.getChild('controlBar').removeChild('captionsMenu')
            this.setState({ displayCaptionsMenu: false })
        } else {
            this.player.getChild('controlBar').addChild('captionsMenu', {
                classes,
                classNames,
                setNewSourceCallback: this.boundSetNewSource,
                captionOptions,
            })
            this.setState({ displayCaptionsMenu: true })
        }
    }

    _setDisplayResMenu() {
        const { classes, srcSet } = this.props
        const { displayResMenu, src } = this.state
        if (displayResMenu) {
            this.player.getChild('controlBar').removeChild('settingMenu')
            this.setState({ displayResMenu: false })
        } else {
            this.player.getChild('controlBar').addChild('settingMenu', {
                classes,
                classNames,
                setNewSourceCallback: this.boundSetNewSource,
                srcOptions: srcSet,
                selectedSrc: src,
            })
            this.setState({ displayResMenu: true })
        }
    }

    _setResizeListener() {
        // https://github.com/yanwsh/videojs-panorama#resize-problem
        this.resizeListener = window.addEventListener('resize', () => {
            var canvas = this.player.getChild('Canvas')
            canvas.handleResize()
        })
    }

    _mountYoutubePlayer() {
        const { media_type, media_is360, poster } = this.props
        const self = this

        const play = () => {
            self.videoNode.play()
        }

        const { src } = this.state
        this.player = videojs(
            this.videoNode,
            {
                controls: false,
                autoplay: true,
                height: '100%',
                width: '100%',
                muted: false,
                techOrder: ['youtube', 'html5'],
                // add plays-line
                sources: [{ type: 'video/youtube', src }],
                youtube: { ytControls: 1 },
                poster,
            },
            play
        )
        if (media_type === 'pano') {
            this._mountPano()
        }
    }

    handleMountNativePlayerLoadedMetaData = () => {
        // Resets to current time when metadata is loaded and plays
        this.player.play()
    }

    _mountNativePlayer() {
        const { media_type, media_is360, poster, classes, captionOptions, srcSet } = this.props

        const { src } = this.state

        this.player = videojs(
            this.videoNode,
            {
                controls: true,
                preload: 'auto',
                autoplay: false,
                height: '100%',
                width: '100%',
                sources: src,
                poster,
                controlBar: {
                    volumePanel: { inline: false },
                },
            },
            function onPlayerReady() {
                // this.videoNode.play()
            }
        )

        if (media_type === 'pano') {
            this._mountPano()
        }

        // let captionMenuButton = this.player.getChild('controlBar').addChild('captionMenuButton', {
        //   classes,
        //   classNames,
        //   captionOptionsLength: captionOptions.length,
        //   clickCallback: this.boundSetDisplayResMenu
        // });
        //
        // captionMenuButton.addClass('vjs-control');
        // captionMenuButton.addClass('vjs-button');
        // captionMenuButton.addClass('vjs-caption-button');

        // Only show settings button if there are multiple sources
        if (srcSet && srcSet.length > 1) {
            let settingMenuButton = this.player.getChild('controlBar').addChild('settingMenuButton', {
                classes,
                classNames,
                clickCallback: this.boundSetDisplayResMenu,
            })

            settingMenuButton.addClass('vjs-control')
            settingMenuButton.addClass('vjs-button')
            settingMenuButton.addClass('vjs-setting-button')
        }

        this.player.on('loadedmetadata', this.handleMountNativePlayerLoadedMetaData)
    }

    _mountPano() {
        panorama(this.player, {
            clickAndDrag: true,
            // Use gyro based on isMobile
            autoMobileOrientation: true,
            // cyclesPerRotation determines how many cycles in video per real-world 360 turn.  Default is 1
            // cyclesPerRotation: 2,
            NoticeMessage: '',
            backToVerticalCenter: false,
            backToHorizonCenter: false,
            initFov: this.props.fov,
        })

        this.player.on('mouseup', this.boundHandleOnMouseUp)
        this.player.on('touchend', this.boundHandleOnMouseUp)
        this.player.on('mousemove', this.handleOnMouseMove)
        this.player.on('touchmove', this.handleOnMouseMove)
        this.player.on('mousedown', this.boundHandleOnMouseDown)
        this.player.on('touchstart', this.boundHandleOnMouseDown)

        this._setResizeListener()
    }

    handleUserInactive = () => {
        let titleDisplay = this.player.getChild('embeddedTitleDisplay')
        let backButton = this.player.getChild('backToSceneButton')

        titleDisplay.addClass('vjs-fade-out')
        backButton.addClass('vjs-fade-out')
    }

    handleUserActive = () => {
        let titleDisplay = this.player.getChild('embeddedTitleDisplay')
        let backButton = this.player.getChild('backToSceneButton')

        titleDisplay.removeClass('vjs-fade-out')
        backButton.removeClass('vjs-fade-out')
    }

    _mountOverlay() {
        const { title, backToScene, enableTitle } = this.props
        // instantiate Video.js

        if (enableTitle) {
            let embeddedTitleDisplay = this.player.addChild('embeddedTitleDisplay', {
                title,
            })
            embeddedTitleDisplay.addClass('vjs-embedded-title')
        }

        let backToSceneButton = this.player.addChild('backToSceneButton', {
            backToScene,
        })
        backToSceneButton.addClass('vjs-scene-return-button')

        this.player.on('userinactive', this.handleUserInactive)
        this.player.on('useractive', this.handleUserActive)
    }

    handleOnMouseDown = e => {
        this.dragged = false

        const { onDragStart } = this.props

        onDragStart && onDragStart(e)
        if (this.props.media_is360) {
            this.setState({ cursor: CursorState.GRABBING })
        }
    }

    handleOnMouseUp = e => {
        if (this.dragged) {
            const { onDragEnd } = this.props

            onDragEnd && onDragEnd(e)
        }
        if (this.props.media_is360) {
            this.setState({ cursor: CursorState.GRAB })
        }
    }

    handleOnMouseMove = () => {
        this.dragged = true
    }

    componentDidMount() {
        const { type, onMouseUp, onTouchEnd } = this.props
        switch (type) {
            case 'aws':
                this._mountNativePlayer()
                this._mountOverlay()
                break
            case 'youtube':
                this._mountYoutubePlayer()
                this._mountOverlay()
                break
            default:
                break
        }
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.off('mouseup', this.boundHandleOnMouseUp)
            this.player.off('touchend', this.boundHandleOnMouseUp)
            this.player.off('mousemove', this.handleOnMouseMove)
            this.player.off('touchmove', this.handleOnMouseMove)
            this.player.off('mousedown', this.boundHandleOnMouseDown)
            this.player.off('touchstart', this.boundHandleOnMouseDown)
            this.player.off('userinactive', this.handleUserInactive)
            this.player.off('useractive', this.handleUserActive)
            this.player.off('loadedmetadata', this.handleNewSourceLoadedMetaData)
            this.player.off('loadedmetadata', this.handleMountNativePlayerLoadedMetaData)

            this.player.dispose()
        }
        if (this.resizeListener) {
            window.removeEventListener('resize', this.resizeListener)
        }
    }

    render() {
        const {
            classes,
            className,
            title,
            type,
            backToScene,
            onEnded,
            onError,
            onPlay,
            onPause,
            media_is360,
            autoPlay,
        } = this.props
        const { src, videoLoaded } = this.state

        let urlArr = src.split('/')
        urlArr[urlArr.length - 1] = 'captions.vtt'
        const captionsURL = urlArr.join('/')
        return (
            <div className={classNames(className, classes.videoContainer)}>
                {videoLoaded && media_is360 && <DraggingHint onClick={e => e.stopPropagation()} />}
                {type === 'aws' || type === 'youtube' ? (
                    <div
                        data-vjs-player
                        style={{
                            cursor: this.state.cursor,
                        }}
                    >
                        {/* Only aws vid needs loading indicator as youtube's comes with player */}
                        {type === 'aws' && (
                            <div
                                className={classNames(classes.loadingIndicator, {
                                    [classes.hidden]: videoLoaded,
                                })}
                            >
                                Loading video...
                            </div>
                        )}
                        <video
                            autoPlay={autoPlay}
                            crossOrigin={'anonymous'}
                            playsInline={true}
                            ref={node => (this.videoNode = node)}
                            className={classNames(classes.media, 'video-js')}
                            onError={onError}
                            onEnded={onEnded}
                            onPlay={onPlay}
                            onCanPlay={this.boundSetVideoLoadedTrue}
                            onPause={onPause}
                        >
                            <track kind="captions" src={captionsURL} srclang="en" label="English" default></track>
                        </video>
                    </div>
                ) : (
                    <VimeoPlayer src={src} title={title} />
                )}
            </div>
        )
    }
}

VideoPlayer.defaultProps = {
    state: 'play',
    progress: 0.5,
    onClick: () => null,
    fov: 80,
    autoPlay: false,
    enableTitle: true,
}

export default compose(injectSheet(style), handlers)(VideoPlayer)
